module.exports = __webpack_public_path__ + "static/media/gucci.ac240d57.jpg";